module.exports = __webpack_public_path__ + "static/media/skrinig40.2adb9ac9.svg";